import axios from "axios";

export const ReturnsService = Object.freeze({
  GetBaseUrl() {
    let result = window.appGlobals.API_URL + "Returns/";
    return result;
  },
  GetReturnsPolicyTitle: function () {
    var reqUrl = window.appGlobals.API_URL + "Returns/ReturnsPolicyTitle";
    return axios.get(reqUrl);
  },
  GetReturnsPolicyUrl: function (title) {
    var returnUrl = "";
    if (title != "") {
      returnUrl = window.appGlobals.PART_IMAGES_API_URL + "Media/FileByTitle?title=" + title;
    }
    return returnUrl;
  },
  SearchReturns: function (accountId, userId, referenceNumber, partNumber) {
    return axios.get(this.GetBaseUrl() + "SearchReturns", {
      params: {
        accountId: accountId,
        userId: userId,
        referenceNumber: referenceNumber,
        partNumber: partNumber,
      },
    });
  },
  GetDraftReturn: function (accountId, userId, draftReturnId) {
    let reqUrl =
      window.appGlobals.API_URL +
      "Returns/DraftDetail?accountId=" +
      accountId +
      "&userId=" +
      userId +
      "&draftReturnId=" +
      draftReturnId;
    return axios.get(reqUrl);
  },
  SubmitReturn: function (accountId, userId, draftReturnId, forceSubmit = false) {
    let reqUrl =
      window.appGlobals.API_URL +
      "Returns/SubmitReturn?accountId=" +
      accountId +
      "&userId=" +
      userId +
      "&draftReturnId=" +
      draftReturnId +
      "&forceSubmit=" +
      forceSubmit;
    return axios.post(reqUrl);
  },
  GetReturnTypes: function (directDealerFlag) {
    let reqUrl = window.appGlobals.API_URL + "Returns/ReturnTypes?directDealerFlag=" + directDealerFlag;
    return axios.get(reqUrl);
  },
  GetPreferredContactMethods: function () {
    let reqUrl = window.appGlobals.API_URL + "Returns/PreferredContactMethods";
    return axios.get(reqUrl);
  },
  GetActionForNonReturnables: function () {
    let reqUrl = window.appGlobals.API_URL + "Returns/ActionForNonReturnables";
    return axios.get(reqUrl);
  },
  GetBlackoutStatus: function (costCenterId) {
    let reqUrl = window.appGlobals.API_URL + "Returns/BlackoutStatus?mcfCostCenterId=" + costCenterId;
    return axios.get(reqUrl);
  },
  SaveDraft: function (accountId, userId, draft) {
    let reqUrl = window.appGlobals.API_URL + "Returns/SaveDraft?accountId=" + accountId + "&userId=" + userId;
    return axios.post(reqUrl, draft);
  },
  GetInvoicesForPart: function (selectedAccountId, userId, oemPartCode, isExpressReturn, removeDateRestriction) {
    let reqUrl =
      window.appGlobals.API_URL +
      "Returns/GetItemInformation?accountId=" +
      selectedAccountId +
      "&userId=" +
      userId +
      "&oemPartCode=" +
      oemPartCode +
      "&isExpressReturn=" +
      isExpressReturn +
      "&removeDateRestriction=" +
      removeDateRestriction;
    return axios.get(reqUrl);
  },
  AddDraftItem: function (selectedAccountId, userId, draftId, returnDraftItemDto) {
    let reqUrl =
      window.appGlobals.API_URL +
      "Returns/AddDraftItem?accountId=" +
      selectedAccountId +
      "&userId=" +
      userId +
      "&draftId=" +
      draftId;
    return axios.post(reqUrl, returnDraftItemDto);
  },
  UpdateDraftItem: function (accountId, userId, draftId, draftItem) {
    return axios.post(this.GetBaseUrl() + "UpdateDraftItem", draftItem, {
      params: {
        accountId: accountId,
        userId: userId,
        draftId: draftId,
      },
    });
  },
  DeleteItemFromReturn: function (accountId, userId, returnDraftId, itemId) {
    let reqUrl = window.appGlobals.API_URL + "Returns/DeleteDraftItem";
    return axios.delete(reqUrl, {
      params: {
        accountId: accountId,
        userId: userId,
        draftId: returnDraftId,
        itemId: itemId,
      },
    });
  },
  GetReturnsSummary: function (accountId, userId, includeDrafts, dealerCodes) {
    return axios.post(
      `${this.GetBaseUrl()}GetReturns?accountId=${accountId}&userId=${userId}&includeDrafts=${includeDrafts}`,
      dealerCodes
    );
  },
  GetSurplusAuthorizedAmounts: function (accountId, userId) {
    return axios
      .get(this.GetBaseUrl() + "SurplusAuthorizedAmounts", {
        params: {
          accountId: accountId,
          userId: userId,
        },
      })
      .then((result) => {
        return [
          {
            label: "Promatch",
            value: result.data.RpAuthorizedRemainingAmount,
          },
          {
            label: "MCF",
            value: result.data.McfAuthorizedRemainingAmount,
          },
        ];
      });
  },
  UploadReturnPartsFile: function (accountId, userId, file) {
    return axios.post(this.GetBaseUrl() + "UploadPartsFile?accountId=" + accountId + "&userId=" + userId, file);
  },
  ProcessFileBatch: function (accountId, userId, draftId, fileBatch) {
    return axios.post(
      this.GetBaseUrl() + "ProcessFileBatch?accountId=" + accountId + "&userId=" + userId + "&draftId=" + draftId,
      fileBatch
    );
  },
  GetReturnDetails: function (returnId, salesOrg, returnSource, accountId, userId, returnType) {
    return axios.get(this.GetBaseUrl() + "ReturnsDetail", {
      params: {
        returnId: returnId,
        salesOrg: salesOrg,
        returnSource: returnSource,
        accountId: accountId,
        userId: userId,
        returnType: returnType,
      },
    });
  },
  DeleteDraftReturn: function (accountId, userId, draftId) {
    return axios.delete(this.GetBaseUrl() + "DeleteDraftReturn", {
      params: {
        accountId: accountId,
        userId: userId,
        draftId: draftId,
      },
    });
  },

  GetAllowedDaysForExpressReturn: function () {
    let reqUrl = window.appGlobals.API_URL + "Returns/GetAllowedDaysForExpressReturn";
    return axios.get(reqUrl);
  }
});
